var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showed)?_c('div',{staticClass:"button-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonRendered),expression:"buttonRendered"}],class:{
      'disabled-payment': _vm.disabled,
    },attrs:{"id":"payment-request-button"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }